import { Container } from '@tryhackme/thm-ui-components';
import styled, { css } from 'styled-components';

export const StyledMainContentOuter = styled.div`
  margin: 3rem 0 6rem 0;
  padding: 0 1.6rem;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledContainer = styled(Container)<{ $isVisible: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.3s ease, visibility 0.3s ease;

  ${({ $isVisible }) =>
    $isVisible &&
    css`
      visibility: visible;
      opacity: 1;
    `}

  > div:nth-of-type(2)  {
    display: flex;
    flex-direction: column;
    gap: 2.4rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    flex-direction: row;

    > div:nth-of-type(2) {
        width: 100%;
        max-width: 41.7rem;
      }
    }
  }
`;
